import React from "react";
import Dropdown from "components/dropdown";
import { Link, useLocation } from "react-router-dom";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import { FiLogOut } from "react-icons/fi";
import avatar from "assets/img/avatars/avatar4.png";
import ChurchSelector from "./ChurchSelector";
import UserBaseUtils from "Utility/UserBase.js";
import StorageKeys from "Utility/StorageKey.js";
import supabase from "supabaseClient";
import StorageBox from "Store/StorageBox.js";

const Navbar = (props: {
  onOpenSidenav: () => void;
  brandText: string;
  secondary?: boolean | string;
}) => {
  const { brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const location = useLocation();

  // Check if user query parameter exists
  const urlParams = new URLSearchParams(location.search);
  const userParam = urlParams.get("user");

  // Modify brandText if viewing another user's profile
  const displayText =
    userParam && brandText === "Profile" ? "User Profile" : brandText;

  // Get current user's profile image
  const getProfileImage = () => {
    const username = UserBaseUtils.getProfileUserName();
    if (username && username !== "Public/Anonymous") {
      return `${StorageKeys.SupabaseUrlProfile}${username}`;
    }
    return avatar; // Fallback to default avatar
  };

  const profileImageUrl = getProfileImage();

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
    } catch (err) {
      console.error("Sign out error:", err);
    }
    StorageBox.removeAllUserDetails();
    window.location.href = "/auth/sign-in";
  };

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {displayText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {displayText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-full flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-fit md:flex-grow-0 md:gap-1 xl:w-fit xl:gap-2">
        {/* start Notification */}

        {/* start Horizon PRO */}

        {/* Church Selector */}
        <ChurchSelector />
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full"
              src={profileImageUrl}
              alt="Profile"
              onError={(e) => {
                // Fallback to orange SVG if profile image fails to load
                const orangeSvg = `data:image/svg+xml,${encodeURIComponent(
                  '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><circle cx="20" cy="20" r="20" fill="#FF9500"/><circle cx="20" cy="16" r="6" fill="#FFFFFF"/><path d="M8 32c0-6.627 5.373-12 12-12s12 5.373 12 12" fill="#FFFFFF"/></svg>'
                )}`;
                (e.target as HTMLImageElement).src = orangeSvg;
              }}
            />
          }
          children={
            <div className="flex w-56 flex-col rounded-xl bg-white p-3 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white">
              <div className="mb-2 border-b border-gray-200 pb-2 dark:border-white/10">
                <p className="text-sm font-bold text-navy-700 dark:text-white">
                  {UserBaseUtils.getProfileUserName() || "Admin"}
                </p>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-red-500 hover:bg-red-50 dark:hover:bg-red-500/10"
              >
                <FiLogOut className="h-4 w-4" />
                Log Out
              </button>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.add("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
